import React from 'react';
import { motion } from 'framer-motion';

export interface AmenityCardProps {
  id: string;
  name: string;
  icon: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

export const AmenityCard: React.FC<AmenityCardProps> = ({
  name,
  icon,
  onClick,
  className = '',
}) => {
  return (
    <motion.button
      onClick={onClick}
      className={`
        relative w-full aspect-square bg-white rounded-2xl p-6
        flex flex-col items-center justify-center
        shadow-[0_2px_8px_rgba(0,0,0,0.08)]
        hover:shadow-[0_4px_16px_rgba(0,0,0,0.12)]
        focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4A054]
        transition-shadow duration-200
        ${className}
      `}
      whileHover={{ y: -4 }}
      whileTap={{ scale: 0.98 }}
      transition={{ duration: 0.2 }}
    >
      {/* Icon Container */}
      <div className="w-20 h-20 rounded-full bg-[#FDF6E9] flex items-center justify-center mb-4">
        <div className="text-[#D4A054] w-16 h-16 flex items-center justify-center">
          {icon}
        </div>
      </div>

      {/* Label */}
      <h3 className="text-[#333333] text-base font-medium text-center">
        {name}
      </h3>

      {/* Arrow Indicator */}
      <div className="text-[#D4A054] text-lg font-bold mt-2">
        &gt;&gt;
      </div>
    </motion.button>
  );
};

export default AmenityCard;
